import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { listOrder, deleteOrder } from "../../actions/orderActions";
import Axios from "../../axios/axios";
import Print from "./Print";
import html2canvas from "html2canvas";
import { ListProducts } from "../../actions/productAction";
import jsPDF from "jspdf";
import { PDFViewer } from "@react-pdf/renderer";
import { PDFDownloadLink, Document, Page } from "@react-pdf/renderer";
import OrderPdf from "../Print/OrderPdf";
import { dateFormat } from "../utils/Utils";
import ConfirmationModal from "../utils/ConfirmationModal";
export default function ExpOrderList() {
  const dispatch = useDispatch();
  const [orders, setOrders] = useState([]);
  const orderList_ = useSelector((state) => state.orderList);
  // const { orders } = orderList_;
  const [showModal, setShowModal] = useState(false);
  const [orderToDelete, setOrderToDelete] = useState(null);
  const [modalMessage, setModalMessage] = useState("");

  const productList = useSelector((state) => state.productList);
  const { products } = productList;

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // const [allOrders, setAllOrders] = useState([]);
  const [keyword, setKeyword] = useState("");

  // useEffect(() => {
  //   fetchOrders();
  // }, [page,keyword]);

  const fetchOrders = async () => {
    const { data } = await Axios.post(`/api/order/expired/list`, {
      page,
      keyword,
    });

    console.log(data, "expired orders");
    setOrders(data);
    setTotalPages(data?.pages);
  };

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  useEffect(() => {
    dispatch(ListProducts({ pagination: false }));
  }, [dispatch]);

  const deleteHandler = (order, orderId) => {
    console.log(order);
    setModalMessage(`Are you sure you want to delete Order ID: ${orderId}?`);
    setOrderToDelete(order);
    setShowModal(true);
  };
  const confirmDelete = () => {
    console.log(orderToDelete, "orderToDelete");
    if (orderToDelete) {
      dispatch(deleteOrder(orderToDelete));
      setShowModal(false);
      setOrderToDelete(null);
      window.location.reload(); // optional, or you can refetch orders instead
    }
  };

  const search = (e) => {
    const value = e.target.value;
    setKeyword(value);
    setPage(1); // important
  };
  useEffect(() => {
    const delay = setTimeout(() => {
      fetchOrders();
    }, 400);

    return () => clearTimeout(delay);
  }, [page, keyword]);

  const editOrder = async (id) => {
    const data = await Axios.get(`/api/order/transaction/${id}`);

    if (data.data === 1) {
      window.location.href = `/order/edit/${id}`;
    } else {
      alert("Cant edit order!");
    }
  };

  const getDelivered = (order) => {
    let result = order?.orderItems?.some((data) => data.isDelivered === false);

    return result;
  };

  const getReturn = (order) => {
    let result = order?.orderItems?.some((data) => data.isReturn === false);

    return result;
  };

  const printDocument = () => {
    const input = document.getElementById("divToPrint");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 50, 0);
      // pdf.output('dataurlnewwindow');
      pdf.save("download.pdf");
    });
  };

  const perPage = 20;
  const startIndex = (page - 1) * perPage;
  const calculateCorrectAmount = (order) => {
    if (!order?.orderItems || order.orderItems.length === 0) {
      return order?.orderAmount || 0;
    }

    const calculatedAmount = order.orderItems.reduce((total, item) => {
      const itemAmount =
        (item.prodPrice || 0) * (item.qnty || 1) * (item.days || 1);
      return total + itemAmount;
    }, 0);

    return calculatedAmount > 0 ? calculatedAmount : order?.orderAmount || 0;
  };

  const getOrderStartDate = (order) => {
    if (!order?.orderItems || order.orderItems.length === 0) return "-";

    const dates = order.orderItems
      .map((item) => item.startDate)
      .filter(Boolean)
      .map((date) => new Date(date));

    if (dates.length === 0) return "-";

    return new Date(Math.min(...dates)).toLocaleDateString();
  };

  const getOrderNoOfDays = (order) => {
    if (!order?.orderItems || order.orderItems.length === 0) return "-";

    const days = order.orderItems.map((item) => {
      if (!item.startDate || !item.endDate) return 0;

      const start = new Date(item.startDate);
      const end = new Date(item.endDate);

      const diff = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;

      return diff > 0 ? diff : 0;
    });

    const maxDays = Math.max(...days);
    return maxDays > 0 ? maxDays : "-";
  };

  return (
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="p-2">
                {" "}
                <h4 class="card-title"> Expired Orders </h4>
              </div>

              <div class="ml-auto p-2">
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search by Order ID,Phone Number Or Customer Name"
                  onChange={search}
                  style={{
                    width: "330px",
                  }}
                />
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Sl No</th>
                    <th>Orderd Date</th>
                    <th>Order Id</th>
                    <th>Customer Name</th>
                    <th>Work Date</th>
                    <th>No of Days</th>
                    <th>Delivered</th>
                    <th>Return</th>
                    <th>Status</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {orders?.data?.length > 0 ? (
                    orders?.data?.map((order, index) => (
                      <tr>
                        <td>{startIndex + index + 1}</td>
                        <td>
                          {/* Only show date in your dateFormat */}
                          {new Date(order?.createdAt).toLocaleDateString()}{" "}
                          <br />
                          {/* Show time separately */}
                          <small>
                            {new Date(order?.createdAt).toLocaleTimeString()}
                          </small>
                        </td>

                        <td>
                          <Link to={`/order/${order._id}`}>
                            ADC_{order?.orderId}
                          </Link>
                        </td>
                        <td>
                          <b>{order?.user?.name}</b> <br />
                          <small>{order?.user?.phone}</small>
                        </td>
                        <td>{getOrderStartDate(order)}</td>
                        <td>{getOrderNoOfDays(order)}</td>
                        <td>
                          {getDelivered(order) === false ? (
                            <i
                              class="icon-check menu-icon"
                              style={{ fontSize: "20px" }}
                            ></i>
                          ) : (
                            "No"
                          )}
                        </td>
                        <td>
                          {" "}
                          {getReturn(order) === false ? (
                            <i
                              class="icon-check menu-icon"
                              style={{ fontSize: "20px" }}
                            ></i>
                          ) : (
                            "No"
                          )}
                        </td>
                        <td>
                          {order?.status === "cancelled" ? (
                            <span className="badge bg-danger">
                              Admin Cancelled
                            </span>
                          ) : order.deleteType === "expired" ? (
                            <span className="badge bg-warning text-dark">
                              Auto Expired
                            </span>
                          ) : (
                            <span className="badge bg-danger">
                              Deleted By Admin
                            </span>
                          )}
                        </td>
                        <td>
                          <b>
                            ₹ {Number(calculateCorrectAmount(order)).toFixed(2)}
                          </b>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6}>No results found for "{keyword}"</td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div style={{ marginTop: "20px" }}>
                <button
                  className="btn btn-secondary"
                  onClick={() => setPage((p) => Math.max(p - 1, 1))}
                  disabled={page === 1}
                >
                  Previous
                </button>

                <span style={{ margin: "0 10px" }}>
                  Page {page} of {totalPages}
                </span>

                <button
                  className="btn btn-primary"
                  onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
                  disabled={page === totalPages}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="exampleModalPrint"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        backdrop={true}
        data-backdrop="static"
      >
        {" "}
        <form class="forms-sample">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  {/* {orderResponse ? orderResponse : 'Summary'} */}
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body" id="divToPrint"></div>

              <div class="modal-footer">
                <a href="/orders">
                  <button type="button" class="btn btn-secondary">
                    Close
                  </button>
                </a>

                <button
                  type="button"
                  class="btn btn-primary"
                  onClick={printDocument}
                >
                  download pdf
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ConfirmationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onConfirm={confirmDelete}
        title="Confirm Delete"
        message={modalMessage}
      />
    </div>
  );
}
